import {
  numberOnly,
  isEmail,
  isPhone,
  moreThanLength,
  lessThanLength,
  betweenLength,
} from '~components/common/forms/UniversalValidations.js'

export const InternSatisfactionBlueprint = [
  {
    type: 'outer',
    key: 'directions',
    class_name: 'flex_row',
    blocks: [
      {
        type: 'span',
        div: 1,
        text: '業界先進 您好：\n感謝貴公司提供本校學生實習機會，讓學子們能有學習與成長的經驗。為了解本校學生於貴公司之實習表現與貴公司對本校學生實習的滿意程度，並關心學生實習之狀況，藉由本問卷彙整各機構之意見，作為未來實習課程之安排與參考，您所填寫的資料僅進行整體分析，不涉及個別資料判別，絕不對外公開，敬請安心作答。 在此致上謝意！',
      },
      {
        type: 'span',
        text: '敬祝 健康如意',
      },
      {
        type: 'span',
        text: '國立臺灣科技大學 敬啟',
      },
    ],
  },
  {
    type: 'section_title',
    text: '壹、基本資料',
  },
  {
    type: 'input',
    key: 'enterprise_name',
    div: 3,
    disabled: true,
    required: true,
    label: '公司名稱：',
    max_length: 500,
  },
  {
    type: 'output_button',
    custom_type: 'date',
    key: 'filling_date',
    div: 3,
    label: '填表日期：',
    icon: 'date',
    check: (cur_val) => {
      if(!cur_val) return '必填';
    },
  },
  {
    type: 'input',
    key: 'company_scorer',
    div: 3,
    required: true,
    label: '實習機構評核者：',
    max_length: 500,
  },
  {
    type: 'input',
    key: 'company_role',
    div: 3,
    required: true,
    label: '職稱：',
    max_length: 500,
  },
  {
    type: 'input',
    key: 'student_name',
    div: 3,
    disabled: true,
    required: true,
    label: '實習生姓名：',
    max_length: 500,
  },
  {
    type: 'select',
    key: 'department_id',
    div: 3,
    disabled: true,
    label: '就讀系所：',
  },
  {
    type: 'outer',
    div: 3,
    blocks: [
      {
        type: 'label',
        text: '實習期間：',
      },
      {
        type: 'output_button',
        custom_type: 'date',
        key: 'start_time',
        icon: 'date',
        check: (cur_val) => {
          if(!cur_val) return '必填';
        },
      },
      {
        type: 'output_button',
        custom_type: 'date',
        key: 'end_time',
        icon: 'date',
        check: (cur_val) => {
          if(!cur_val) return '必填';
        },
      },
    ],
  },
  {
    type: 'input',
    key: 'intern_content',
    div: 'grow',
    required: true,
    max_length: 500,
    label: '實習生職稱或實習內容：',
  },
  {
    type: 'section_title',
    text: '貳、對本校學生整體表現滿意度',
  },
  {
    type: 'radio_table',
    key: 'check',
    required: true,
    label: '一、行政運作',
    options: ['非常滿意', '滿意', '尚可', '不滿意', '非常不滿意'],
    values: [5, 4, 3, 2, 1],
    items: [
      '1. 出席情形',
      '2. 工作之態度與積極度',
      '3. 工作執行能力(是否能完成交付的任務)',
      '4. 工作期間與同事之相處情形',
      '5. 工作期間與主管相處情形(是否能聽從主管指示)',
      '6. 敬業精神',
      '7. 挫折容忍度',
      '8. 工作之品質效率',
      '9. 團隊合作能力',
      '10.表達與溝通能力',
      '11.創造力',
      '12.規劃組織能力',
      '13.服裝儀容',
      '14.品格操守',
      '15.整體表現滿意度',
      '16.願意與本校繼續合作，繼續提供其他學生實習機會',
      '17.願意繼續聘任此位學生，提供學生就業機會',
    ],
  },
  {
    type: 'section_title',
    text: '参、其他意見分享：',
  },
  {
    type: 'textarea',
    key: 'opinion_share',
    max_length: 500,
    required: true,
  },
];
